import React from 'react';
import { useFilterContext } from '../../context/aptmetrix/FilterContext';
import { useTooltip } from './useTooltip';
import { handleCommaNumberInput, formatPriceDisplay } from './inputHelpers';
import FilterButton from './FilterButton';
import TooltipShell, { FilterActions } from './TooltipShell';

const PriceFilter = ({ isOpen, onToggle, onClose, selectedRegion, data, onFilterChange }) => {
    const {
        filterUIState,
        setFilterUIState,
        setPriceFilter,
    } = useFilterContext();

    const { minPrice, maxPrice, isPriceFilterActive } = filterUIState;

    const { tooltipRef, buttonRef } = useTooltip(isOpen, onClose);

    const updateUI = (updates) => setFilterUIState(prev => ({ ...prev, ...updates }));
    const setMinPrice = (v) => updateUI({ minPrice: v });
    const setMaxPrice = (v) => updateUI({ maxPrice: v });

    const handleToggle = () => {
        if (!selectedRegion) {
            alert('지역을 먼저 선택하세요');
            return;
        }
        onToggle();
    };

    const apply = () => {
        const minVal = minPrice ? parseInt(minPrice.replace(/,/g, ''), 10) : null;
        const maxVal = maxPrice ? parseInt(maxPrice.replace(/,/g, ''), 10) : null;
        updateUI({ isPriceFilterActive: minVal !== null || maxVal !== null });
        setPriceFilter({ minPrice: minVal, maxPrice: maxVal });
        onFilterChange({ minPrice: minVal, maxPrice: maxVal });
        onClose();
    };

    const reset = () => {
        updateUI({ minPrice: '', maxPrice: '', isPriceFilterActive: false });
        setPriceFilter({ minPrice: null, maxPrice: null });
        onFilterChange({ minPrice: null, maxPrice: null });
        onClose();
    };

    const isDisabled = !data || data.length === 0;

    return (
        <div className="relative">
            <FilterButton
                ref={buttonRef}
                label="매매가"
                activeLabel="매매가적용"
                isActive={isPriceFilterActive}
                isDisabled={isDisabled}
                onClick={handleToggle}
            />
            {isOpen && (
                <TooltipShell ref={tooltipRef} title="매매가 설정" onClose={onClose}>
                    <div className="flex items-center justify-between mb-3">
                        <input
                            type="text"
                            value={minPrice}
                            onChange={(e) => handleCommaNumberInput(e, setMinPrice)}
                            placeholder="최소 금액"
                            className="w-24 p-1 border border-gray-300 rounded-lg text-center text-sm"
                        />
                        <span className="mx-1">~</span>
                        <input
                            type="text"
                            value={maxPrice}
                            onChange={(e) => handleCommaNumberInput(e, setMaxPrice)}
                            placeholder="최대 금액"
                            className="w-24 p-1 border border-gray-300 rounded-lg text-center text-sm"
                        />
                    </div>
                    <div className="text-xs text-gray-500 mb-2">
                        <div className="text-right">(단위: 만원)</div>
                        {(minPrice || maxPrice) && (
                            <div className="mt-1 p-2 bg-gray-50 rounded text-gray-700">
                                {minPrice && <div>최소: {formatPriceDisplay(minPrice)}</div>}
                                {maxPrice && <div>최대: {formatPriceDisplay(maxPrice)}</div>}
                            </div>
                        )}
                    </div>
                    <FilterActions onReset={reset} onApply={apply} />
                </TooltipShell>
            )}
        </div>
    );
};

export default PriceFilter;
